<script>
  import Icon from '../Icon/'
  import { cssPrefix } from '../helper-classes.js'

  export let info = ''
  export let icon = null
  export let selected = false

  const slots = $$slots
</script>

<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<div class={`${cssPrefix}menu-item`} class:is-selected={selected} tabindex="0" role="button" on:click on:keydown>
  {#if icon}
    {#if typeof icon === 'string'}
      <Icon name={icon} />
    {:else}
      <Icon {icon} />
    {/if}
  {/if}
  <div class={`${cssPrefix}menu-content`}>
    <slot />
  </div>
  {#if info}
    <span class={`${cssPrefix}menu-info`}>
      {info}
    </span>
  {/if}
</div>
